module.exports = __webpack_public_path__ + "img/ec-w.fc163a44.svg";